import React from 'react';
import { Box, CircularProgress, SxProps, Theme } from '@mui/material';
import { LoadingSpinnerProps } from './types';
import { getSpinnerContainerSx, getCircularProgressSx } from './styles';

const LoadingSpinner: React.FC<LoadingSpinnerProps> = React.memo(
  ({
    size = 40,
    strokeWidth = 4,
    color = 'primary.main',
    label = 'Loading',
    sx = {},
  }) => {
    const containerSx = [getSpinnerContainerSx(), sx] as SxProps<Theme>;

    return (
      <Box sx={containerSx} data-testid="LoadingSpinner">
        <CircularProgress
          size={size}
          thickness={(strokeWidth / size) * 10}
          sx={getCircularProgressSx(color)}
          aria-label={label}
        />
      </Box>
    );
  }
);

LoadingSpinner.displayName = 'LoadingSpinner';

export default LoadingSpinner;
